import { useContext } from 'react';

import { UserSettingsContext } from '@/spaces/settings/UserSettingsContext';
import type { UserSettingsContextValue } from '@/spaces/settings/userSettingsTypes';

export const useUserSettings = (): UserSettingsContextValue => {
	const context = useContext(UserSettingsContext);
	if (!context) {
		throw new Error('useUserSettings must be used within UserSettingsProvider');
	}
	return context;
};
